<template>
	<a v-bind="linkProps" class="venue-info-section">
		<div class="venue-info-section__icon-wrapper mr-8">
			<component :is="firstIconName" class="venue-info-section__icon-start" />
		</div>
		<slot />
		<div class="venue-info-section__icon-wrapper ml-auto">
			<open-icon class="venue-info-section__icon-end" />
		</div>
	</a>
</template>

<script>
// Icons
import PinIcon from '@/assets/svg/ic_pin_mobile_prev.svg'
import OpenIcon from '@/assets/svg/open_icon.svg'
import PhoneIcon from '@/assets/svg/ic_phone_mobile_prev.svg'
import MailIcon from '@/assets/svg/mail_icon_mobile_prev.svg'

export default {
	name: 'VenueInfoSection',

	components: { PinIcon, OpenIcon, PhoneIcon, MailIcon },

	props: {
		firstIconName: {
			type: String,
			default: 'pin-icon'
		},

		link: {
			type: String,
			required: true
		},

		target: {
			type: String,
			default: ''
		}
	},

	computed: {
		linkProps() {
			const props = {
				href: this.link
			}

			if (this.target) {
				props.target = this.target
			}

			return props
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.venue-info-section {
	display: flex;
	align-items: center;
	padding: 16px 0;
	color: $white;
	font-size: 14px;
	line-height: 16px;
	border-bottom: 1px solid $royal-purple;
	text-decoration: none;

	.bold {
		font-size: 16px;
		line-height: 18px;
	}

	&__icon-start {
		color: $soft-lavender;
	}

	&__icon-end {
		color: $grand-blue;
	}

	&__icon-wrapper {
		padding: 8px;
		width: 48px;
		height: 48px;
	}
}
</style>
